<template>
    <div class="simple-column">
        <div class="fl up-column">
            <div class="value">{{ up | getNumber() }}</div>
            <div class="deail-num" :style="{'background':'#e63030', 'height': upHeight + 'px', 'min-height': up == 0? '' : (minHeight + 'px') } ">
                 {{ up | showNull() }}
            </div>
            <div class="detail-word">涨</div>
        </div>
        <div class="fl equal-column">
            <div class="value">{{ equal | getNumber() }}</div>
            <div class="deail-num" :style="{background:'#515151', height: equalHeight + 'px', 'min-height': equal == 0 ? '' : (minHeight + 'px') }">
                 {{ equal | showNull() }}
            </div>
            <div class="detail-word">平</div>
        </div>
        <div class="fl down-column">
            <div class="value">{{ down | getNumber() }}</div>
            <div class="deail-num" :style="{background:'#22ac38', height: downHeight + 'px', 'min-height': down == 0 ? '': (minHeight + 'px') }">
                {{ down | showNull() }}
            </div>
            <div class="detail-word">跌</div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['up', 'equal', 'down'],
    data () {
        return {
            minHeight: 6,
            maxHeight: 52,
            defaultHeight: 24,
            upHeight: 24,
            equalHeight: 24,
            downHeight: 24
        }
    },
    mounted () {
        this.calculationHeight()
    },
    methods: {
        checkNull(){
            if(this.up == '-' || this.up == '--'){
                this.upHeight = this.defaultHeight
            }
            if(this.equal == '-' || this.equal == '--'){
                this.equalHeight = this.defaultHeight
            }
            if(this.down == '-' || this.down == '--'){
                this.downHeight = this.defaultHeight
            }
        },
        null2Zero(val){
            if(val == '-' || val ==  '--') return 0;
            return val
        },
        calculationHeight() {  
            let upHeight,  equalHeight, downHeight;
            upHeight = this.null2Zero(this.up)
            equalHeight = this.null2Zero(this.equal)
            downHeight = this.null2Zero(this.down)
            this.setHeight(upHeight, equalHeight, downHeight)
        },
        setHeight(upHeight, equalHeight, downHeight){
            try {
                let max = Math.max(upHeight, equalHeight, downHeight)
                this.upHeight = this.maxHeight * (upHeight/ max) 
                this.equalHeight = this.maxHeight * (equalHeight / max) 
                this.downHeight = this.maxHeight * (downHeight / max) 
                this.checkNull();
            }catch(e){
                this.checkNull();
            }
        }
    },
    watch: {
        up(){
            this.calculationHeight()
        },
        down(){
            this.calculationHeight()
        },
        equal(){
            this.calculationHeight()
        }
    },
    filters:{
        getNumber(val){
            if(val == '-' || val == '--'){
                return '';
            }
            return val ;
        },
        showNull(val){
            if(val == '-' || val == '--'){
                return '-';
            }
            return '';
        }
    }
}
</script>

<style lang="less">
.newgrey{
    .simple-column{
        background-color: #181c21;
    }
}
.newblack{
    .simple-column{
        background-color: #ffffff;
    }
}
.simple-column {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-end;
    background-color: #19191b;
    .up-column, .equal-column, .down-column {
        display: flex;
        flex-direction: column;
        min-width: 28px;
        align-items: center;
        .deail-num {
            width: 12px;
            // line-height: 1;
            color: #ffffff;
            max-height: 52px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .detail-word {
            margin-bottom: 6px;
        }
    }
}
</style>
